import Audio from "@fae/source/utility/Audio.js"
import Navigation from "@fae/source/engine/navigating/Navigation.js"
import App from "@fae/source/models/App.js"

import * as PlotSteps from "@fae/source/data/plot/steps.js"

import chX_0 from "./chapters/X-0/index.js"
import chX_1 from "./chapters/X-1/index.js"
import test from "./chapters/test/index.js"
import protoencounters from "./chapters/protoencounters/index.js"

import player from "./player.js"
import unitJobs from "./unitJobs.jsx"
import skills from "./skills.js"
import overworlds from "./overworlds.js"

import LoadingScreen from "./views/screens/LoadingScreen.jsx"
import TitleScreen from "./views/screens/TitleScreen.jsx"
import EmbarkScreen from "./views/screens/EmbarkScreen.jsx"

export default {
    "key": "ember",
    "title": "Embergrim",
    "introduction": "Made for the Pigsquad Summer Slow Jams",
    "type": "wine",
    "player": player,
    "unitJobs": unitJobs,
    "skills": skills,
    "overworlds": overworlds,
    "chapters": {
        "X-0": chX_0,
        "X-1": chX_1,
        "test": test,
        "protoencounters": protoencounters,
    },
    "screens": {
        "TitleScreen": TitleScreen,
        "LoadingScreen": LoadingScreen,
        "EmbarkScreen": EmbarkScreen,
    },
    "openingEvents": function() {
        return [
            // PlotSteps.TransitionStart(),
            {"func": () => Navigation.go("/games/ember/chapters/X-0")},
            // PlotSteps.Wait(1000),
            // PlotSteps.TransitionEnd(),
        ]
    },
    "configuration": {
        "darkness": "none",
        "squigglevision": false,
        "isRenderingEquippedItemOnUnit": true,
        "useEquippedItemOnly": true,
    },
    "analytics": {
        "gameKey": "d6c6e7375b8eb6352d0064fc096041c3",
        "secretKey": "790add480ca72c5dcc8c81a0145a67aa57ff6957",
    },
    "images": {
        "images": {
            "ember-beacon": require("@fae/source/assets/images/ember-tactics/sprites/torch/sprite-item-torch1.png"),
            "ember-beacon-outline": require("@fae/source/assets/images/ember-tactics/sprites/torch/sprite-item-torch1-outline.png"),
            "ember-flame": require("@fae/source/assets/images/ember-tactics/sprites/torch/sprite-item-torch1-fire1.png"),
            // "plant1": require("@fae/source/assets/images/apocalypse-tactics/environment/vegetation/KiwiSquash/Crop01_KiwiSquash_1b_Flowering.png"),
            // "plant1-item": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),

            "embark-screen-background": require("@fae/source/assets/images/ember-tactics/screens/embark/embarkscreen3.png"),
            "card-back": require("@fae/source/assets/images/ember-tactics/screens/embark/cardback.png"),
            "card-portrait-background": require("@fae/source/assets/images/ember-tactics/screens/embark/cardbackground.png"),

            "title-screen-background": require("@fae/source/assets/images/ember-tactics/screens/title/titlescreen.lowres.png"),
            "logo": require("@fae/source/assets/images/ember-tactics/embergrim.logo.png"),

            // TODO: pull these from ./overworlds.js
            "overworld-screen-woods-0": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-3-base.lowres.png"),
            "overworld-screen-woods-1": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-2-beacon-DIM.png"),
            "overworld-screen-woods-2": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/papertexture-screensize.lowres.png"),
            "overworld-screen-woods-3": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/overworldmaps-frame.lowres.png"),

            // TODO: pull these from ./envkits.js
            "envkit-woods-tallwall-0": require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-34-farBG1-BAKED.lowres.png"),
            "envkit-woods-tallwall-1": require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-34-farBG2-BAKED.lowres.png"),
            "envkit-woods-tallwall-2": require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-34-farBG3-BAKED.lowres.png"),
            // "envkit-woods-farwall": require("@fae/source/assets/images/ember-tactics/env/woods/test/BG-woods-30-farBG-example.png"),
            "envkit-woods-nearwall": require("@fae/source/assets/images/ember-tactics/env/woods/test/BG-woods-35-nearBG-example.png"),
            "envkit-woods-floor":require("@fae/source/assets/images/ember-tactics/env/woods/test/BG-woods-10-floorbasic.png"),
            // "envkit-woods-bush-0": require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-24-wallMID-large.png"),
            // "envkit-woods-bush-1": require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-26-wallLIGHT-large.png"),
        },
        "weapons": {
            "ember-axe": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-axe.png"),
            "ember-bow": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-bow.png"),
            "ember-daggers": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-daggers.png"),
            "ember-spear": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-spear.png"),
            "ember-blue-staff": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-staffblue.png"),
            "ember-green-staff": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-staffgreen.png"),
            "ember-red-staff": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-staffred.png"),
            "ember-sword": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-sword.png"),
            "ember-torch": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-torch.png"),
        },
    },
    "audio": {
        // "Ember:Music:Combat": {
        //     "volume": 0.32,
        //     "label": "music",
        //     "kill": {"label": "music"},
        //     "audio": new Audio(require("@fae/source/assets/audio/borrowed/pyre-pathtoglory.mp3"))
        // },
        // "Ember:Music:Wander": {
        //     "volume": 0.32,
        //     "label": "music",
        //     "kill": {"label": "music"},
        //     "audio": new Audio(require("@fae/source/assets/audio/borrowed/pyre-willofthescribes.mp3"))
        // },
        // "Ember:Music:Sad": {
        //     "volume": 0.32,
        //     "loop": false,
        //     "label": "music",
        //     "kill": {"label": "music"},
        //     "audio": new Audio(require("@fae/source/assets/audio/borrowed/httyd - forbidden friendship.mp3"))
        // },
        "Dialogue:Blip": {
            "volume": 0.3,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@fae/source/assets/audio/horror-tactics/select-move1.mp3")),
                new Audio(require("@fae/source/assets/audio/horror-tactics/select-move2.mp3")),
            ],
        },
        "Card:Flip": {
            "volume": 0.3,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/Card_Game_Movement_Deal_Single_Whoosh_01.mp3")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Card_Game_Movement_Deal_Single_Whoosh_02.mp3")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Card_Game_Movement_Deal_Single_Whoosh_03.mp3")),
            ],
        },
        "Merchant:Triple": {
            "volume": 0.3,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/Card_Game_Achievement_Poof_01.mp3")),
            ],
        },
        "Merchant:Coins": {
            "volume": 0.5,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Few_00.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Few_01.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Few_02.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Few_03.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Few_04.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Few_05.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Few_06.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Few_07.wav")),
            ],
        },
        "Merchant:Coins:Single": {
            "volume": 0.5,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Single_00.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Single_01.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Single_02.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Single_03.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Coins_Single_04.wav")),
            ],
        },
        "Merchant:Gems": {
            "volume": 0.5,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/Gems_Few_00.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Gems_Few_01.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Gems_Few_02.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Gems_Few_03.wav")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/Gems_Few_04.wav")),
            ],
        },
        "UI:Confirm": {
            "volume": 0.3,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/Card_Game_Alert_Turn_Pass_02.mp3")),
            ],
        },
        "Unit:Death:Knell": {
            "volume": 0.5,
            // "audio": new Audio(require("@fae/source/assets/audio/horror-tactics/death-knell.mp3"))
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_fatal_blow_track1_80BPM.ogg"))
        },
        "Unit:Harvest": {
            "volume": 0.2,
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/Card_Game_Action_Click_Bubble_01.mp3")),
        },
        "Unit:Kindle": {
            "volume": 0.2,
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/Card_Game_Action_Drip_Fire_01.mp3")),
        },
        "Dice:Roll": {
            "volume": 0.3,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@fae/source/assets/audio/dice-tactics/sounds/Player_rolling.wav")),
                new Audio(require("@fae/source/assets/audio/dice-tactics/sounds/Player_rolling_lighter.wav")),
            ],
        },
        "Stinger:Success": {
            "volume": 0.37,
            "label": "music",
            "type": "once",
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_success_stinger.ogg")),
            "kill": {"label": "music"},
        },
        "Stinger:Failure": {
            "volume": 0.37,
            "label": "music",
            "type": "once",
            "audio": new Audio(require("@fae/source/assets/audio/dice-tactics/musics/Dice_Tactics_lose_stinger.wav")),
            "kill": {"label": "music"},
        },
        "Stinger:Start": {
            "volume": 0.37,
            "label": "music",
            "type": "once",
            "audio": new Audio(require("@fae/source/assets/audio/dice-tactics/sounds/Game_Start.wav")),
            "kill": {"label": "music"},
        },
        "Stinger:PlayerTurn": {
            "volume": 0.37,
            "type": "once",
            "audio": new Audio(require("@fae/source/assets/audio/dice-tactics/sounds/Game_Player_Phase.wav")),
        },
        "Stinger:EnemyTurn": {
            "volume": 0.37,
            "type": "once",
            "audio": new Audio(require("@fae/source/assets/audio/dice-tactics/sounds/Game_Enemy_Phase.wav")),
        },
        "Ambience:Forest": {
            "key": "Ambience:Forst",
            "volume": 0.5,
            "loop": true,
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/music/Forest_ambience.ogg")),
            "label": "ambience",
            "kill": {"label": "ambience"},
        },
        "Ambience:Campfire": {
            "key": "Ambience:Campfire",
            "volume": 0.2,
            "loop": true,
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/music/Campfire_and_night_ambienece.ogg")),
            "label": "ambience",
            "kill": {"label": "ambience"},
        },
        "Ember:Music:Encounter:1": {
            "key": "Ember:Music:Encounter:1",
            "volume": 0.3,
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_track_1A_dice_roll_loop.ogg")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_track_1B_battle_loop.ogg")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Encounter:2": {
            "key": "Ember:Music:Encounter:2",
            "volume": 0.3,
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_track_2A_dice_roll_loop.ogg")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_track_2B_battle_loop.ogg")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Encounter:3": {
            "key": "Ember:Music:Encounter:2",
            "volume": 0.3,
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_track_3A_dice_roll.ogg")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_track_3B_battle_loop.ogg")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Campfire": {
            "key": "Ember:Music:Campfire",
            "volume": 0.4,
            "type": "sequence:march",
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_campfire_track_loop.ogg")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Titlescreen": {
            "key": "Ember:Music:Titlescreen",
            "volume": 0.4,
            "type": "sequence:march",
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_Title_Track_Loop.ogg")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Boss": {
            "volume": 0.3,
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_boss_level_dice_roll_loop.ogg")),
                new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_boss_level_battle_loop.ogg")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Fairytale": {
            "volume": 0.2,
            "loop": true,
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_Crow_theme_loop.ogg")),
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Death:Ashe": {
            "volume": 0.2,
            "loop": true,
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_Ashe_funeral_rites_ver.2_loop.ogg")),
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Death:Gwyn": {
            "volume": 0.2,
            "loop": true,
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_Gwyn_funeral_rites_loop.ogg")),
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Death:Kullervo": {
            "volume": 0.2,
            "loop": true,
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_Kullervo_funeral_rites_loop.ogg")),
            "label": "music",
            "kill": {"label": "music"},
        },
        "Ember:Music:Death:Mara": {
            "volume": 0.2,
            "loop": true,
            "audio": new Audio(require("@fae/source/assets/audio/ember-tactics/music/Embergrim_Mara_funeral_rites_loop.ogg")),
            "label": "music",
            "kill": {"label": "music"},
        },
        "Dicebound:Music:1A": {
            "volume": 0.3,
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_1A_dice_roll_loop.wav")),
                new Audio(require("@fae/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_1A_battle_loop.wav")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
        "Dicebound:Music:1B": {
            "volume": 0.3,
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_1B_dice_roll_loop.wav")),
                new Audio(require("@fae/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_1B_battle_loop.wav")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
        "Dicebound:Music:2": {
            "volume": 0.3,
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_2_dice_roll_loop.wav")),
                new Audio(require("@fae/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_2_battle_loop.wav")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
        "Dicebound:Music:Boss": {
            "volume": 0.3,
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@fae/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_boss_level_dice_roll_loop.wav")),
                new Audio(require("@fae/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_boss_level_battle_loop.wav")),
            ],
            "label": "music",
            "kill": {"label": "music"},
        },
    },
    "credits": [
        "Andrew Goodenough",
        "Anna Arkhipova",
        "Liv McPherson",
        "Ed Varga",
    ],
    "titleMusicKey": "Ember:Music:Titlescreen",
    // "titleMusicKey": "Dicebound:Music:2",
}

function FadeInOutWhilePlaying(stage) {
    if(this.audio[0].paused != true) {
        if(Math.abs(this.audio[0].currentTime - this.audio[1].currentTime) > 0.1) {
            this.audio[1].currentTime = this.audio[0].currentTime
            console.warn("AUDIO DESYNC")
        }
    }

    if(stage?.player?.phase != "playing" || App.game?.chapter?.selection?.isRerolling == true) {
        this.audio[1].volume = tween(this.audio[1].volume, 0)
    } else {
        this.audio[1].volume = tween(this.audio[1].volume, this.audio[0].volume)
    }
}

function tween(currentValue, intendedValue) {
    const rate = Math.abs(intendedValue - currentValue) / 4
    if(rate < 0.01) {
        currentValue = intendedValue
    } else if(currentValue < intendedValue) {
        currentValue += rate
        currentValue = Math.min(currentValue, intendedValue)
    } else if(currentValue > intendedValue) {
        currentValue -= rate
        currentValue = Math.max(currentValue, intendedValue)
    }
    return currentValue
}
